export const getMatrixItemByFlavor = (matrixItems, flavourId) => matrixItems.find((item) => {
    if (!flavourId) {
        return false;
    }
    return item.flavorDetails?.flavour === flavourId;
});
//# sourceMappingURL=getMatrixItemByFlavor.js.map